module.exports = __webpack_public_path__ + "img/899-ec5526.png";